import { render, staticRenderFns } from "./printQueue.vue?vue&type=template&id=f1bc036a&scoped=true"
import script from "./printQueue.vue?vue&type=script&lang=js"
export * from "./printQueue.vue?vue&type=script&lang=js"
import style0 from "./printQueue.vue?vue&type=style&index=0&id=f1bc036a&prod&lang=scss&scoped=true"
import style1 from "./printQueue.vue?vue&type=style&index=1&id=f1bc036a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bc036a",
  null
  
)

export default component.exports